import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LoadingOverlay from '@components/LoadingOverlay';
import {
  ContentArea,
  FilterButton,
  Wrapper,
} from '@components/SearchResults';

import Results from './components/Results';
import SearchFilters from './components/SearchFilters';

const CalqResults = ({
  loading,
  filtersOptions,
  filtersValues,
}) => (
  <Wrapper>
    {loading && <LoadingOverlay />}
    <ContentArea>
      <SearchFilters
        filtersOptions={filtersOptions}
        filtersValues={filtersValues}
      />
      <Results />
      <FilterButton
        href="#"
      >
        Filter Options
      </FilterButton>
    </ContentArea>
  </Wrapper>
);

CalqResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  filtersOptions: PropTypes.shape({
    otherResourceCategoryFilters: PropTypes.arrayOf(PropTypes.object),
    practiceAreaFilters: PropTypes.arrayOf(PropTypes.object),
    publicationFilters: PropTypes.arrayOf(PropTypes.object),
    resourceTypeFilters: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  filtersValues: PropTypes.shape({
    dateRangeEnd: PropTypes.string,
    dateRangeStart: PropTypes.string,
    keyword: PropTypes.string,
    otherResources: PropTypes.arrayOf(PropTypes.object),
    practiceAreas: PropTypes.arrayOf(PropTypes.object),
    publications: PropTypes.arrayOf(PropTypes.object),
    resourceTypes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

const mapStateToProps = ({
  calqSearch: {
    filters,
    loading,
    results,
  },
}) => ({
  filtersValues: filters,
  loading,
  results,
});

CalqResults.displayName = 'CalqResults';

export default connect(mapStateToProps)(CalqResults);
